// @flow
import { useDoctorSelection, withDoctorSelectionModal } from '@coverright/widgets';
import * as React from 'react';
import { MedicareQuoteQuery } from '@coverright/data-access/medicare';
import { Button, ButtonBase, Collapse, Divider, Skeleton, Stack, Typography } from '@mui/material';
import { DoctorItem } from './doctor-item';
import { Portal } from '../../../../../shared';
import { CaretDown } from '@phosphor-icons/react';
import { useState } from 'react';


const View = (props: {quote: MedicareQuoteQuery['medicareQuote']}) => {
  const {doctors, handleAddClick, handleEditClick, handleDeleteClick} = useDoctorSelection()
  const [open, setOpen] = useState(false);

  return (<Stack gap={1} flex={1}>
    <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
      <Typography variant={'subtitle1'}>Doctors {!!doctors.length && `(${doctors.length})`}</Typography>
      <Button size={'small'} onClick={handleAddClick}>Add doctor</Button>
    </Stack>
    {!!doctors.length && <Portal>
      {doctors.slice(0, 4).map((item, i) => (
        <React.Fragment key={item.npi}>
          <DoctorItem doctor={item}
                      onDeleteClick={() => handleDeleteClick(item)}
                      onEditClick={() => handleEditClick(item)} />
          {i < doctors.length - 1 && <Divider sx={{}} />}
        </React.Fragment>
      ))}

      {doctors.length > 4 && <>
        <Collapse in={open}>
          {doctors.slice(4).map((item, i) => (
            <React.Fragment key={item.npi}>
              <DoctorItem doctor={item}
                          onDeleteClick={() => handleDeleteClick(item)}
                          onEditClick={() => handleEditClick(item)} />
              {i < doctors.length - 1 && <Divider sx={{}} />}
            </React.Fragment>
          ))}
        </Collapse>
        <ButtonBase sx={{py: .5, gap: .5}} onClick={() => setOpen(!open)}>
          <Typography variant={'caption'} color={'text.secondary'}>
            Show {open ? 'less' : 'more'}
          </Typography>
          <CaretDown size={12} weight={'bold'} style={{transition: 'all .3s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)'}} />
        </ButtonBase>
      </>}

    </Portal>}
    {!doctors.length && <Stack alignItems={'center'} height={50} justifyContent={'center'}>
      <Typography variant={'body2'} color={'#a5a5a5'}>No doctors added</Typography>
    </Stack>}
  </Stack>);
};

export const Doctors = withDoctorSelectionModal(View, true)

export const DoctorsSkeleton = () => (
  <Stack gap={1} flex={1}>
    <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
      <Typography variant={'subtitle1'}>Doctors</Typography>
    </Stack>
    <Portal gap={1} p={2}>
      <Skeleton variant={'rounded'} width={'100%'} height={40} />
      <Skeleton variant={'rounded'} width={'100%'} height={40} />
    </Portal>
  </Stack>
)
